var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title"},[_c('h3',{staticClass:"font-weight-bold my-5",class:{ 'text-left' : _vm.left }},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"underline"})])}
var staticRenderFns = []

export { render, staticRenderFns }